/* eslint-disable no-undefined */
export const isPropertyEmpty = (property: any) =>
  property === null || property === undefined;
